export const APP_PATHS = {
    frontDoor: '/',
    businessHome: '/DevSolutions',
    register: '/register',
    login: '/login',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    privacyPolicy: '/PrivacyPolicy',
    dataDeletion: '/DataDeletion',
    subscription: '/subscribe',
    administration: '/UserManagement',
    connections: '/connections',
    connectionCredentials: '/connections/:connectionId/credentials',
    home: '/Unity',
    workspaces: '/workspaces',
    organization: '/organization',
    apiAccess: '/api-access',
    connectApp: '/connect',
    docs: '/docs',
    docsArticle: '/docs/:slug',
    reportWorkspace: '/report/:reportId',
    publicLink: '/p/:token',
} as const;

export const APP_ROUTE_PATHS = Object.values(APP_PATHS);
